import actionTypes from 'redux/actionTypes';

export const setSelectedStartDate = (date?: string, period?: string) => ({
    type: actionTypes.SELECTED_START_DATE_SET,
    payload: { date, period },
});
